import axios from "axios";
import {Account} from "@/scripts/types/account";

export const getAccount: () => Promise<Account> = async () => {
    const url = '/api/account/current';
    const response = await axios.get(url);

    return response.data as Account;
};